import Keycloak from "../node_modules/keycloak-js/lib/keycloak";

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KC_SERVER,
    realm: process.env.REACT_APP_KC_REALM,
    clientId: process.env.REACT_APP_KC_CLIENT_ID
});


export default keycloak;